import React from "react";
import { useGlobalContext } from "../Context/GlobalContext";

const BlockReportsNavbar = ({ setActiveReportPage, activeReportPage }) => {
  const pages = [
    "Block Reports",
    "New Section Wise Block (Eng)",
    "Agreed And Given Block (Eng)",
    "Machine (Eng)",
    "Block Not Availed",
    "Block Position",
    "ADRM Daily Block Position Report",
    "Material Train Report",
    "COM ENGG Position",
    "TWS Block Report",
    "Eng Crew Demand Position",
    "Path wastage",
    "Non Working",
    "Section Wise Block",
    "Caution Order",
    "Custom Report",
  ];

  const handleBtnClick = (page) => {
    setActiveReportPage(page);
  };

  return (
    <div className="ms-2 me-2">
      <div className="reports-navbar ">
        <div className="reports-navbar-inner">
          <div className="reports-title">
            <span className="reports-title-line"></span>
            <span>Reports</span>
          </div>

          <div className="reports-buttons">
            {pages.map((pageName, index) => (
              <button
                key={index}
                type="button"
                onClick={() => handleBtnClick(pageName)}
                className={`report-nav-btn ${
                  activeReportPage === pageName ? "report-nav-active" : ""
                }`}
                style={{
                  background:
                    activeReportPage === pageName
                      ? "linear-gradient(135deg, #870606 0%, #732f08 100%)"
                      : undefined,
                }}
              >
                <span className="report-nav-number">
                  {String(index + 1).padStart(2, "0")}
                </span>

                <span className="report-nav-text">{pageName}</span>

                <span className="report-nav-arrow">›</span>
              </button>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default BlockReportsNavbar;
